import { api } from "../api";
import { VehicleParameter } from "../../../types/types";

const saveVehicleParameter = async (
    token: string,
    vehicleParameter: VehicleParameter,
) => {
    const response = await api.post<void>(
        "/vehicle-parameters",
        vehicleParameter,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    return response;
};

export default saveVehicleParameter;
